import "react-toastify/dist/ReactToastify.css";
import { CsvUploader } from "@common/UploadCsvTemplate";
import LoadingIcon from "@common/LoadingIcon";
import { userHeaderMapping } from "@services/TranslateCsvHeaders";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import { expectedUserHeaders } from "@constants/CsvHeaders";
import { sampleUserData } from "@constants/SampleData";
import { UseUserCsvUploadPage } from "@pages/User/UserCSVUploadPage/hooks/UseUserCsvUploadPage";

const UserCSVUploadPage = () => {
  const form = UseUserCsvUploadPage();

  return (
    <div className="relative">
      {(form.loading || form.isProcessing) && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-5 rounded-lg shadow-lg flex items-center justify-center">
            <LoadingIcon
              bodyText={
                form.isProcessing
                  ? `${form.processedCount || 0} / ${form.csvData.length || 0}`
                  : ""
              }
              footerText={messages.csv.do_not_close}
            />
          </div>
        </div>
      )}
      <CsvUploader
        titleText={pageHeaders.USER.csvUpload}
        expectedUserHeaders={expectedUserHeaders}
        uploadHandler={form.handleCsvUpload}
        setCsvData={form.setCsvData}
        csvData={form.csvData}
        onCancel={form.onCancel}
        sampleData={sampleUserData}
        failedUsers={form.failedUsers}
        templateName={`社内電話帳用CSVサンプル_${form.currentDate}`}
        headerMapping={userHeaderMapping}
        fromPage={"user"}
      />
    </div>
  );
};

export default UserCSVUploadPage;
